// extracted by mini-css-extract-plugin
module.exports = {"feature_wrapper":"subscription-feature_feature_wrapper__UoKgj","tick":"subscription-feature_tick__ddLC5"};